// Kotodama (言霊, #543): a contender said the secret word. Over the whole screen, the word stamped in the middle and
// basho yen raining down on it, then gone; the bout goes on underneath. Reduced motion: the stamp alone, no rain.
import { reduced } from "./dom.ts";

/** how long the rain lasts, ms; how many marks fall */
const RAIN_MS = 5200,
  MARKS = 42;

const esc = (s: string) =>
  s.replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c] as string);
const MARK = `<span class="by" aria-hidden="true"><span>B</span><span>Y</span></span>`;
const yen = (n: number) =>
  `<span class="yen"><span class="by" aria-label="basho yen"><span>B</span><span>Y</span></span>${n.toLocaleString("en-US")}</span>`;

/** the rain, over the whole screen, for this event */
export function rain(k: KotodamaEvent) {
  document.querySelector(".kotodama-rain")?.remove();
  const layer = document.createElement("div");
  layer.className = "kotodama-rain";
  layer.setAttribute("role", "status");
  const paid = k.stable ? `${yen(k.bounty)} to ${esc(k.stable)}` : "no stable: the word burns";
  layer.innerHTML = `<div class="stamp"><span class="kanji" lang="ja">言霊</span><b class="word">${esc(k.word)}</b><span class="paid">${paid}</span></div>`;
  if (!reduced && k.bounty > 0) {
    for (let i = 0; i < MARKS; i++) {
      const m = document.createElement("span");
      m.className = "fall";
      m.innerHTML = MARK;
      m.style.setProperty("--x", `${(Math.random() * 100).toFixed(1)}%`);
      m.style.setProperty("--d", `${(Math.random() * 1.6).toFixed(2)}s`);
      m.style.setProperty("--t", `${(1.8 + Math.random() * 1.8).toFixed(2)}s`);
      m.style.setProperty("--r", `${Math.round(Math.random() * 720 - 360)}deg`);
      m.style.setProperty("--s", `${(0.8 + Math.random() * 1.1).toFixed(2)}`);
      layer.append(m);
    }
  }
  document.body.append(layer);
  setTimeout(() => layer.remove(), reduced ? RAIN_MS / 2 : RAIN_MS);
}
